module.exports = __webpack_public_path__ + "img/user-student.271afdec.svg";